export default __webpack_public_path__ + "media/images/testimonials/testimonial-dog-body-e2f5fda939d0655d738d0cb3e5077e29.svg";